export default __webpack_public_path__ + "static/media/svg-2.cc23b2dc.svg";